import { gql } from "@apollo/client";

export const getFileByIdAdditional = gql(`
    query GetTermsAndConditionsById($fileId: String!) {
      getTermsAndConditionsById(id: $fileId) {
        fileName
        contentType
        downloadUrl
      }
    }
  `);